export const LOCAL_STORAGE_USER_ID = 'palyxUserId';
export const LOCAL_STORAGE_USER_TOKEN = 'palyxToken';
export const LOCAL_STORAGE_LANGUAGE = 'palyxi18nextLng';
export const LOCAL_STORAGE_LAST_ACTION_TIMESTAMP = 'lastActionTimestamp';
